import { useRouteChangeEvent } from "@circle-react/hooks/utils/useRouteChangeEvent";
import { useWidgetNavigationListener } from "@circle-react/hooks/utils/useWidgetNavigationListener";

export interface RouteChangeEventWrapperProps {
  children: React.ReactNode;
}

export const RouteChangeEventWrapper = ({
  children,
}: RouteChangeEventWrapperProps) => {
  useRouteChangeEvent();
  useWidgetNavigationListener();
  return <>{children}</>;
};
